import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=a17655b0&"
import script from "./ExamList.vue?vue&type=script&lang=js&"
export * from "./ExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports